import { CHECKOUT_ITEM_TYPE_FLIGHT } from 'constants/checkout'

export function isFlightItem(item: App.Checkout.AnyItem): item is App.Checkout.FlightItem {
  return item.itemType === CHECKOUT_ITEM_TYPE_FLIGHT
}
